import React from 'react';

import BillingInformationForm from 'components/common/BillingInformationForm/BillingInformationForm';
import BillingInformationData from 'components/common/BillingInformationData/BillingInformationData';

import Modal from '@core/components/Modal/Modal';
import ActionButton from '@core/components/actionbutton/ActionButton';
import Spinner from '@core/components/spinner/Spinner';

import UseModal from 'hooks/use-modal';
import UseToast from 'hooks/use-toast';

import { MOBILE_FULLSCREEN } from '@core/constants/ModalTypes';

import EditIcon from 'assets/icons/edit-icon.svg';

import classes from './CartBillingInformation.module.scss';

const CartBillingInformation = ({
	billingInformationData,
	isLoadingBillingInfo,
	refetchBillingAddress,
	callback
}) => {
	const { ToastContainer, toast } = UseToast();

	const {
		show: showAddBillingAddress,
		showModal: showAddBillingAddressHandler,
		destroyModal: destroyAddBillingAddress
	} = UseModal();

	return (
		<>
			{!isLoadingBillingInfo ? (
				<>
					{billingInformationData?.data?.country_iso &&
						billingInformationData?.data?.postal_code &&
						billingInformationData?.data?.city &&
						billingInformationData?.data?.address_line_1 ? (
						<>
							<div
								className={`d-flex flex-row align-items-center justify-content-end mb-3 ${classes['update-billing-btn']}`}>
								<ActionButton onClick={showAddBillingAddressHandler}>
									<EditIcon />
								</ActionButton>
							</div>
							<BillingInformationData billingAddress={billingInformationData?.data} />
						</>
					) : (
						<div className={classes['billing-address-form-modal']}>
							<BillingInformationForm
								callback={() => {
									callback && callback();
									refetchBillingAddress && refetchBillingAddress();
								}}
								toast={toast}
								billingAddress={billingInformationData?.data}
								hasSubmitMsg={true}
							/>
						</div>
					)}
				</>
			) : (
				<div className="d-flex align-items-center justify-content-center w-100 py-5">
					<Spinner />
				</div>
			)}
			<Modal
				title="Add billing information"
				show={showAddBillingAddress}
				closeHandler={destroyAddBillingAddress}
				type={MOBILE_FULLSCREEN}>
				<div className={`${classes['billing-address-form-modal']}`}>
					<BillingInformationForm
						callback={() => {
							callback && callback();
							destroyAddBillingAddress();
						}}
						toast={toast}
						billingAddress={billingInformationData?.data}
						hasSubmitMsg={true}
					/>
				</div>
			</Modal>
			<ToastContainer />
		</>
	);
};

export default CartBillingInformation;
